var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-container"},_vm._l((_vm.lines),function(line,index){return _c('div',{key:index,staticClass:"skeleton-line",style:({
      width: _vm.getRandomWidth(index),
      height: _vm.height + 'px',
      borderRadius: _vm.borderRadius,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }